const businessMain = {
    "studio": {
        "name": "Morkem Photo & Video Studio",
        "location": "Kathrikkadavu, Kaloor, Ernakulam",
        "category": "Photography",
        "description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
        "banner": {
            "title": "Professional Wedding Photography",
            "image": "banner_image_url",
            "link": "banner_link_url"
        },
        "tabs": [
            {
                "name": "Works",
                "active": true,
                
            },
            {
                "name": "Catalogue",
                "active": false,
               
            },
            {
                "name": "About",
               
            }
        ],
        "contact_button": {
            "icon": "whatsapp_icon_url",
            "link": "whatsapp_link_url"
        }
    }
}
const businessCatalog = {
    "packages": [
        {
            "id": 1,
            "name": "Crystal Luxury",
            "price": 175000,
            "description": "This photography package is ideal for Elephant Sized weddings Four days of shoot including Pre wedding/save the date, Haldi, Mehandi, Sangeeth, Wedding & reception covering Bride and Groom side. Photographers: 3, Videographers: 3, Drone: Included, Live streaming on YouTube. Deliverables: Unlimited Photos soft copy, 100 Page album for Bride, 100 Page album for Groom, Highlight Video, Full Video Wedding, Save the date Reels.",
            "image": "https://wallpaperaccess.com/full/4274939.jpg"

        },
        {
            "id": 2,
            "name": "Diamond Luxury",
            "price": 200000,
            "description": "This photography package is ideal for Elephant Sized weddings Four days of shoot including Pre wedding/save the date, Haldi, Mehandi, Sangeeth, Wedding & reception covering Bride and Groom side. Photographers: 3, Videographers: 3, Drone: Included, Live streaming on YouTube. Deliverables: Unlimited Photos soft copy, 100 Page album for Bride, 100 Page album for Groom, Highlight Video, Full Video Wedding, Save the date Reels.",
            "image": "https://th.bing.com/th/id/OIP.B6tAozw6Ste7-OO0FUE8HwHaD4?w=600&h=314&rs=1&pid=ImgDetMain"

        },
        {
            "id": 3,
            "name": "Platinum Luxury",
            "price": 250000,
            "description": "This photography package is ideal for Elephant Sized weddings Four days of shoot including Pre wedding/save the date, Haldi, Mehandi, Sangeeth, Wedding & reception covering Bride and Groom side. Photographers: 3, Videographers: 3, Drone: Included, Live streaming on YouTube. Deliverables: Unlimited Photos soft copy, 100 Page album for Bride, 100 Page album for Groom, Highlight Video, Full Video Wedding, Save the date Reels.",
            "image": "https://wallpaperaccess.com/full/4274939.jpg"

        }
    ]
}
const businessAbout = {
    "business_info": {
        "address": {
            "location": "Kathrikkadavu, Kaloor, Ernakulam 686569, Kerala",
        },
        "contact": {
            "number": "+91 9995657689",
            "name": "Sijo Jacob"
        },
        "social_media": {
            "whatsapp": "+91 9995657689",
            "instagram": "Sijo_Jacob",
            "facebook": "Sijo Jacob",
            "website": "www.morkemphoto.com"
        }
    }
}
export { businessMain, businessCatalog, businessAbout }